import React from 'react';

import { SongType } from '../../../../types';

// Title + artist text. The link wrapping it lives in SongRow so the whole row
// (not just this text) navigates to the song.
const SongHeading = ({ song }: SongHeadingTypes) => (
	<>
		<p className="title-font" style={titleStyle}>
			{song.title}
		</p>
		<p className="secondary-text-color" style={artistStyle}>
			{song.artist}
		</p>
	</>
);

type SongHeadingTypes = {
	song: SongType;
};

const titleStyle: React.CSSProperties = {
	fontSize: 20,
	fontWeight: 'bold',
	margin: 0,
};

const artistStyle: React.CSSProperties = {
	fontSize: 14,
	margin: 0,
};

export default SongHeading;
